// extracted by mini-css-extract-plugin
export var statItem = "_jn-1";
export var statsRow = "_jn-0";